import DispatchIcon from '@returnmates/ui-core/src/components/imageComponents/header/DispatchIcon'
import EntitiesIcon from '@returnmates/ui-core/src/components/imageComponents/header/EntitiesIcon'
import InventoryIcon from '@returnmates/ui-core/src/components/imageComponents/header/InventoryIcon'
import OperationsIcon from '@returnmates/ui-core/src/components/imageComponents/header/OperationsIcon'
import ToolsIcon from '@returnmates/ui-core/src/components/imageComponents/header/ToolsIcon'
import BarcodeScannerIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/BarcodeScanner'
import ConsolidationIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Consolidations'
import ContainersIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Containers'
import LocationsIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Locations'
import ManifestsIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Manifests'
import OperationsTabIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Operations'
import PackagesIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Packages'
import PartnersIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Partners'
import PrintIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Print'
import TripsIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Trips'
import UsersIcon from '@returnmates/ui-core/src/components/imageComponents/tabs/Users'

import {
  AUDITS,
  COMMUNICATIONS,
  CONSOLIDATIONS,
  CONTAINERS,
  DASHBOARD,
  LOCATIONS,
  MANIFEST,
  OPERATIONS,
  PACKAGE_LOG,
  PARTNERS,
  PRINT,
  QR,
  ROUTES,
  SAVERS,
  TRIPS_LOG,
  USERS,
  ZIP_CODES,
} from '../../constants/paths'
import { SECTIONS } from '../Sidebar/constants'
import { PageInfo } from './types'

export const PAGE_INFO: { [key: string]: PageInfo } = {
  [DASHBOARD]: {
    section: SECTIONS.DASHBOARD,
    hasTabs: false,
    link: DASHBOARD,
  },
  [ROUTES]: {
    icon: <DispatchIcon />,
    title: '/ Routes',
    section: SECTIONS.DISPATCH,
    hasTabs: true,
    tabTitle: 'Routes',
    tabIcon: <DispatchIcon />,
    link: ROUTES,
  },
  [TRIPS_LOG]: {
    icon: <DispatchIcon />,
    title: '/ Trips',
    section: SECTIONS.DISPATCH,
    hasTabs: true,
    tabTitle: 'Trips',
    tabIcon: <TripsIcon />,
    link: TRIPS_LOG,
  },
  [PACKAGE_LOG]: {
    icon: <InventoryIcon />,
    title: '/ Packages',
    section: SECTIONS.INVENTORY,
    hasTabs: true,
    tabTitle: 'Packages',
    tabIcon: <PackagesIcon />,
    link: PACKAGE_LOG,
  },
  [CONSOLIDATIONS]: {
    icon: <InventoryIcon />,
    title: '/ Consolidations',
    section: SECTIONS.INVENTORY,
    hasTabs: true,
    tabTitle: 'Consolidations',
    tabIcon: <ConsolidationIcon />,
    link: CONSOLIDATIONS,
  },
  [CONTAINERS]: {
    icon: <InventoryIcon />,
    title: '/ Containers',
    section: SECTIONS.INVENTORY,
    hasTabs: true,
    tabTitle: 'Containers',
    tabIcon: <ContainersIcon />,
    link: CONTAINERS,
  },
  [USERS]: {
    icon: <EntitiesIcon />,
    title: '/ Users',
    section: SECTIONS.ENTITIES,
    hasTabs: true,
    tabTitle: 'Users',
    tabIcon: <UsersIcon />,
    link: USERS,
  },
  [LOCATIONS]: {
    icon: <EntitiesIcon />,
    title: '/ Locations',
    section: SECTIONS.ENTITIES,
    hasTabs: true,
    tabTitle: 'Locations',
    tabIcon: <LocationsIcon />,
    link: LOCATIONS,
  },
  [QR]: {
    icon: <ToolsIcon />,
    title: '/ Barcode Scanner',
    section: SECTIONS.TOOLS,
    hasTabs: true,
    tabTitle: 'Barcode Scanner',
    tabIcon: <BarcodeScannerIcon />,
    link: QR,
  },
  [AUDITS]: {
    icon: <ToolsIcon />,
    title: '/ Audits',
    section: SECTIONS.TOOLS,
    hasTabs: true,
    tabTitle: 'Audits',
    link: AUDITS,
  },
  [SAVERS]: {
    icon: <ToolsIcon />,
    title: '/ Savers',
    section: SECTIONS.TOOLS,
    hasTabs: true,
    tabTitle: 'Savers',
    link: SAVERS,
  },
  [PRINT]: {
    icon: <ToolsIcon />,
    title: '/ Print',
    section: SECTIONS.TOOLS,
    hasTabs: true,
    tabTitle: 'Print',
    tabIcon: <PrintIcon />,
    link: PRINT,
  },
  [COMMUNICATIONS]: {
    icon: <ToolsIcon />,
    title: '/ Delivery Notes',
    section: SECTIONS.TOOLS,
    hasTabs: true,
    tabTitle: 'Delivery Notes',
    link: COMMUNICATIONS,
  },
  [PARTNERS]: {
    icon: <OperationsIcon />,
    title: '/ Partners',
    section: SECTIONS.OPERATIONS,
    hasTabs: true,
    tabTitle: 'Partners',
    tabIcon: <PartnersIcon />,
    link: PARTNERS,
  },
  [ZIP_CODES]: {
    icon: <OperationsIcon />,
    title: '/ Zip Codes',
    section: SECTIONS.OPERATIONS,
    hasTabs: true,
    tabTitle: 'Zip Codes',
    link: ZIP_CODES,
  },
  [MANIFEST]: {
    icon: <OperationsIcon />,
    title: '/ Manifests',
    section: SECTIONS.OPERATIONS,
    hasTabs: true,
    tabTitle: 'Manifests',
    tabIcon: <ManifestsIcon />,
    link: MANIFEST,
  },
  [OPERATIONS]: {
    icon: <OperationsIcon />,
    title: '/ Operations',
    section: SECTIONS.OPERATIONS,
    hasTabs: true,
    tabTitle: 'Operations',
    tabIcon: <OperationsTabIcon />,
    link: OPERATIONS,
  },
}
